<!--
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2023-05-18 08:58:30
 * @Description: 
-->
<template>
  <div class="config">
    <Form ref="configData"
          :model="config"
          action="javascript:void(0)">
      <FormItem label="背景图">
        <upload-thumb v-model="config.mangheqiang_backphoto"
                      ref="uploadthumb"
                      :defaultList="thumblist"
                      :defaultTip="'图片格式:jpg、jpeg、png,大小不超过2M'"></upload-thumb>
      </FormItem>
      <FormItem label="隐藏入口"
                label-position="top">
        <RadioGroup v-model="config.is_show_index">
          <Radio :label="0">是</Radio>
          <Radio :label="1">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="默认打开"
                label-position="top">
        <RadioGroup v-model="config.is_default_open">
          <Radio :label="1">是</Radio>
          <Radio :label="0">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="搜索类型"
                label-position="top">
        <RadioGroup v-model="config.search_type">
          <Radio :label="1">按姓氏精准搜索</Radio>
          <Radio :label="2">按格子精准搜索</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem>
        <Button type="primary"
                @click="handleSubmit('configData')">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>
  
  
<script>
import UploadThumb from "../../common/thumb";

export default {
  name: "config",
  data () {
    return {
      config: {
        is_show_index: 1,
        is_default_open: 0,
        search_type: 1
      },
      uploadthumb: [],
      thumblist: []
    };
  },
  components: {
    UploadThumb
  },
  created: function () {
    this.getConfig();
  },
  methods: {
    handleSubmit (name) {
      if (this.$refs["uploadthumb"].uploadList.length > 0) {
        this.config.mangheqiang_backphoto = this.$refs["uploadthumb"].uploadList[0].url;
      } else {
        this.config.mangheqiang_backphoto = null;
      }
      this.$api.mangheset.edit(this.config).then(res => {
        if (res.code == 200) {
          this.$Message.success("修改成功...");
        }
      });
    },
    getConfig: function () {
      this.$api.mangheset.detail().then(res => {
        if (res.result) {
          this.config = res.result.config;
          if (this.config.mangheqiang_backphoto != null && this.config.mangheqiang_backphoto != "") {
            this.thumblist.push({
              name: this.config.mangheqiang_backphoto,
              url: this.config.mangheqiang_backphoto,
              status: "finished"
            });
          }
        }
      });
    }
  }
};
  </script>
  
